import React, { FC } from 'react'
import { cn } from 'shared/utils'

import { isOdd } from 'shared/utils'
import { ChartsRow } from 'modules/Charts/components'

import { IChartsProps } from './Charts.props'

import './Charts.scss'

const Charts: FC<IChartsProps> = ({ charts, factSources, assignedСampaigns }) => (
  <div className="charts__rows">
    {charts.map((row, index) => (
      <div className="charts__row" key={`chartsRow__${index}`}>
        <div
          className={cn('charts__item charts__item--rank', {
            'charts__item--grey': isOdd(index)
          })}
          key={`chartPosition__${index}`}
        >
          <div className="charts__item-content">{row.rank}</div>
        </div>
        <ChartsRow
          factSources={factSources}
          index={index}
          row={row}
          columnsLength={factSources.length}
          assignedСampaigns={assignedСampaigns}
        />
      </div>
    ))}
  </div>
)

export default Charts
